import { useTranslation } from 'react-i18next'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { ProcessorDetails } from '@/lib/api/processors'
import { initApmSettingsFromOptions } from '../../components/processor-apm-settings'

interface TagadaPayRouterApmCardProps {
    processor: ProcessorDetails
}

export const TagadaPayRouterApmCard = ({ processor }: TagadaPayRouterApmCardProps) => {
    const { t } = useTranslation('processors')

    const apmSettings = initApmSettingsFromOptions(
        'tagadapay-router',
        (processor.options as any)?.apmSettings as Record<string, Record<string, unknown>> | undefined,
    )

    const entries = Object.entries(apmSettings)
    const enabled = entries.filter(([, s]) => s.enabled)
    const disabled = entries.filter(([, s]) => !s.enabled)

    return (
        <Card className="mb-6">
            <CardHeader>
                <CardTitle>{t('tagadapayRouter.alternativePaymentMethods')}</CardTitle>
            </CardHeader>
            <CardContent>
                {enabled.length === 0 ? (
                    <p className="text-sm text-muted-foreground">{t('tagadapayRouter.noApmsEnabled')}</p>
                ) : (
                    <div className="space-y-4">
                        <div>
                            <p className="text-xs text-muted-foreground mb-2">{t('enabled')}</p>
                            <div className="space-y-2">
                                {enabled.map(([key, state]) => (
                                    <div key={key} className="flex items-center gap-3">
                                        <img
                                            src={state.logoUrl}
                                            alt={state.label}
                                            className="h-5 w-auto object-contain"
                                        />
                                        <span className="text-sm font-medium">{state.label}</span>
                                        {(state.supportedCountries?.length ?? 0) > 0 && (
                                            <span className="text-xs text-muted-foreground">
                                                {state.supportedCountries!.length} {t('countries')}
                                            </span>
                                        )}
                                        <Badge variant="secondary" className="ml-auto text-xs">
                                            {t('enabled')}
                                        </Badge>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {disabled.length > 0 && (
                            <div>
                                <p className="text-xs text-muted-foreground mb-2">{t('disabled')}</p>
                                <div className="flex flex-wrap gap-2">
                                    {disabled.map(([key, state]) => (
                                        <Badge key={key} variant="outline" className="text-muted-foreground gap-1.5">
                                            <img
                                                src={state.logoUrl}
                                                alt={state.label}
                                                className="h-3 w-auto object-contain opacity-50"
                                            />
                                            {state.label}
                                        </Badge>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </CardContent>
        </Card>
    )
}
